import { enqueueTelemetryEvents, getTelemetryClientConfig } from '@ms/yammer-telemetry-store';

import type { AnalyticsV2Event, BaseTelemetryEvent } from '../events';

import { getThrottledReportAnalyticsV2EventsInBatch } from './reportInBatches';

type EnqueueAndThrottleReportAnalyticsV2Events = <T extends BaseTelemetryEvent>(events: T[]) => void;
const enqueueAndThrottleReportAnalyticsV2Events: EnqueueAndThrottleReportAnalyticsV2Events = <
  T extends BaseTelemetryEvent,
>(
  events: T[]
) => {
  enqueueTelemetryEvents<T>('AnalyticsV2', events);
  const throttledReportAction = getThrottledReportAnalyticsV2EventsInBatch(
    // istanbul ignore next
    getTelemetryClientConfig()?.eventReportIntervalInMilliseconds ?? 0
  );

  throttledReportAction();
};

type ReportAnalyticsV2Event = (event: AnalyticsV2Event) => void;
export const reportAnalyticsV2Event: ReportAnalyticsV2Event = (event) => {
  const clientConfig = getTelemetryClientConfig();
  if (!clientConfig) {
    return;
  }

  enqueueAndThrottleReportAnalyticsV2Events([event]);
};
